export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const CHANGE_IDIOMA = 'CHANGE_IDIOMA';
export const LOADING='LOADING';
export const NOTIFICAR='NOTIFICAR';
export const UPDATE_FAZENDA_CARACTERIZADA='UPDATE_FAZENDA_CARACTERIZADA';
export const UPDATE_LIST_REFERENCIA='UPDATE_LIST_REFERENCIA';